import * as API from '../api'
import { authType } from '../utils/auth'

export const FETCH_AUTH = 'FETCH_AUTH'
export const FETCHING_AUTH = 'FETCHING_AUTH'
export const FETCH_AUTH_ERROR = 'FETCH_AUTH_ERROR'
export const CLEAR_AUTH = 'CLEAR_AUTH'
export const CHANGE_STATE_AREA = 'CHANGE_STATE_AREA'
export const STOP_FETCHING = 'STOP_FETCHING'
export const FETCH_HEADERS = 'FETCH_HEADERS'
export const FETCHING_HEADERS = 'FETCHING_HEADERS'
export const FETCH_HEADERS_ERROR = 'FETCH_HEADERS_ERROR'
export const CLEAR_HEADERS = 'CLEAR_HEADERS'
export const STOP_FETCHING_HEADERS = 'STOP_FETCHING_HEADERS'

export const signIn = () => {
  return dispatch => {
    dispatch({ type: CLEAR_AUTH })
    dispatch({ type: CLEAR_HEADERS })

    API.auth.redirectToSignIn()
  }
}

export const fetchAuth = token => {
  return dispatch => {
    dispatch({ type: FETCHING_AUTH })
    dispatch({ type: FETCHING_HEADERS })

    return API.auth
      .getAuthorization(token)
      .then(response => {
        const { headers, data = {} } = response

        const { name: userName,
                user_id: userId,
                area_id: areaId,
                area_code: areaCode,
                area_name: areaName,
                area_responsible: areaResponsible,
                business_unit_responsible: businessUnitResponsible,
                can_change_area: canChangeArea,
                permissions,
                profile_document_url
                } = data                

        dispatch({
          type: FETCH_HEADERS,
          tokenType: headers['token-type'],
          accessToken: headers['access-token'],
          client: headers['client'],
          expiry: headers['expiry'],
          uid: headers['uid']
        })

        dispatch({
          type: FETCH_AUTH,
          userName,
          userId,
          areaId,
          areaName,
          areaCode,
          areaResponsible,
          businessUnitResponsible,
          canChangeArea,
          permissions,
          profile_document_url
        })
      })
      .catch(err => {
        dispatch({ type: FETCH_AUTH_ERROR })
      })
  }
}

export const clearAuth = () => {
  return dispatch => {
    dispatch({ type: CLEAR_AUTH })
    dispatch({ type: CLEAR_HEADERS })

    if (authType('adfs')) {
      API.auth.redirectToSignOut()
    }
  }
}

export const stopFetching = () => {
  return dispatch => {
    dispatch({ type: STOP_FETCHING })
    dispatch({ type: STOP_FETCHING_HEADERS })
  }
}

export const changeStateArea = (areaId, areaName, areaCode, areaResponsible, businessUnitResponsible) => {
  return dispatch => {
    dispatch({
      type: CHANGE_STATE_AREA,
      areaId,
      areaName,
      areaCode,
      areaResponsible,
      businessUnitResponsible
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/auth.js